import { defineComponent } from 'vue';
import AnnualHumanResourceComponent from '@/components/AnnualHumanResource/AnnualHumanResourceComponent.vue';
export default defineComponent({
    name: 'AnnualHumanResource',
    components: { AnnualHumanResourceComponent },
    data() {
        return {};
    }
});
